import { createSlice } from '@reduxjs/toolkit';
import { Employee } from 'views/ProviderProfile/types';

export interface VisaPageManagement {
    pageSectionName: 'Agreement' | 'Documents' | '';
}

export interface EmployeeListState {
    list: Employee[];
}

const initialState: EmployeeListState = {
    list: [
        // {
        //     firstname: 'Kyrylo',
        //     middlename: '',
        //     lastname: 'Lovushkin',
        //     email: 'example@gmail.com',
        //     role: 'manager',
        //     id: '1',
        //     phone_number: '+99487946464',
        // },
        // {
        //     firstname: 'Michael',
        //     middlename: '',
        //     lastname: 'Bay',
        //     email: 'michael.bay@gmail.com',
        //     role: 'manager',
        //     id: '2',
        //     phone_number: '+99487946464',
        // },
        // {
        //     firstname: 'Jose',
        //     middlename: 'Patrico',
        //     lastname: 'Santos',
        //     email: 'jose.patrico.santos@yahoo.com',
        //     role: 'manager',
        //     id: '3',
        //     phone_number: '+99487946464',
        // },
    ],
};

const employeeListSlice = createSlice({
    name: 'employee_list',
    initialState,
    reducers: {
        loadEmployees(state, action) {
            state.list = action.payload;
        },
        removeEmployee(state, action) {
            state.list = state.list.filter((user) => user.id !== action.payload);
        },
        addEmployee(state, action) {
            state.list.push(action.payload);
        },
        updateEmployee(state, action) {
            const targetUserIndex = state.list.findIndex((user) => user.id === action.payload.id);

            if (targetUserIndex) {
                state.list[targetUserIndex] = action.payload;
            }
        },
    },
});

export const { loadEmployees, removeEmployee, addEmployee, updateEmployee } =
    employeeListSlice.actions;
export default employeeListSlice.reducer;
